import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

export const isFocusable = (element) => {
  const tabIndex = element.getAttribute('tabIndex');

  return !isNil(tabIndex) && !isEmpty(tabIndex) && tabIndex !== '-1';
};

export const getAccessibleElementSearcher = (onBeenFound) => {
  let isFound = false;

  const searchAccessible = (element) => {
    if (isFound) {
      return;
    }

    if (!isFocusable(element)) {
      for (let i = 0; i < element.children.length; i += 1) {
        if (isFound) {
          break;
        }

        searchAccessible(element.children[i]);
      }
    } else {
      isFound = true;

      onBeenFound(element);
    }
  };

  return (parent) => {
    searchAccessible(parent);
  };
};
